import { render } from "./Index.vue?vue&type=template&id=0c4a15ac&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0c4a15ac"

export default script